import React, { useState } from 'react';
import { Box, Typography, IconButton } from '@material-ui/core';
import { Edit, Close as CloseIcon } from '@material-ui/icons';
import { TabletButton } from '@campfire/tablet-button';
import { StringParam, useQueryParam } from 'use-query-params';
import { SimpleAvailabilityComponent } from '../../../../../../../common/simple-availability-select/SimpleAvailabilitySelect';

interface Props {
  onClose: () => void;
}

export const SimpleAvailabilityView = ({ onClose }: Props) => {
  const [selectedVolunteerProfileId] = useQueryParam('volunteerProfileId', StringParam);
  const [isEditing, setIsEditing] = useState(false);

  return (
    <>
      <Box
        display='flex'
        alignItems='center'
        justifyContent='space-between'
        padding='8px 16px'
        borderBottom='1px solid #DCDCDC'
      >
        <Typography style={{ fontWeight: 600, fontSize: 16 }}>Availability</Typography>
        <Box display='flex' alignItems='center'>
          <TabletButton
            variant='outlined'
            onClick={() => setIsEditing(!isEditing)}
            startIcon={<Edit />}
            style={{ borderRadius: '4px', paddingLeft: '4px', paddingRight: '4px' }}
          >
            {isEditing ? 'Done' : 'Edit'}
          </TabletButton>
          <Box marginLeft={1}>
            <IconButton onClick={() => onClose()}>
              <CloseIcon color='action' />
            </IconButton>
          </Box>
        </Box>
      </Box>

      <Box
        flex={1}
        style={{ overflowY: 'scroll', backgroundColor: '#f6f8f9', width: '100%', paddingTop: '15px' }}
        display='flex'
      >
        <Box position='relative' display='flex' flex='1 1 auto' height={'auto'} minHeight={1} justifyContent={'center'}>
          {selectedVolunteerProfileId && (
            <SimpleAvailabilityComponent profileId={selectedVolunteerProfileId} editing={isEditing} showEmpty />
          )}
        </Box>
      </Box>
    </>
  );
};
